import React,{useState,useEffect} from 'react'
import { Icon,Card,Dialog,Collapse,Alert } from "@blueprintjs/core";
import { doc, updateDoc, deleteDoc,collection, query, where, limit, onSnapshot } from 'firebase/firestore'
import db from '../firebase/config'
import { useAuthState } from 'react-firebase-hooks/auth';
import {getAuth} from 'firebase/auth'
import Stack2 from './Stack2'
import moment from 'moment';
import { LinkPreview } from '@dhaiwat10/react-link-preview';
moment().format();
const auth = getAuth()

function Item(props) {
    //style={{backgroundColor:'#5C255C'}}
    const [visible,setVisible] = useState(false)
    const [show,setShow] = useState(false)
    const [new_name,setNewName] = useState("")
    const [edit,setEdit] = useState(false)
    const [disabled,setDisabled] = useState(false)
    const {title, itemDocId, timeStamp,shared} = props.info
    const [share,setShare] = useState(false)
    const [alert,setAlert] = useState(false)
    const [user] = useAuthState(auth)
    const [allStacks,setAllStacks] = useState([])
    const [initial,setInitial] = useState(30)
    const [stack,showStacks] = useState(false)
    let timeNew = new Date(timeStamp.seconds * 1000)
    const [clipAlerts,setClipAlerts] = useState(false)


    
   const CopyToClipboardFn = async() => {
    navigator.clipboard.writeText(title);
    setClipAlerts(prev=>!prev);
    }

    

    const updateItem = async ()=>{
        let docRef = doc(db, "items",itemDocId)
        await updateDoc(docRef,{
             title:new_name,
        })
        await setNewName("")
    }

    const deleteItem = async ()=>{
        let docRef = doc(db, "items",itemDocId);
        await deleteDoc(docRef)
        await setVisible(false)
    }

    const shareItem = async ()=>{
        let timeStamp = moment.utc()
        let docRef = doc(db, "items",itemDocId)
        await updateDoc(docRef,{
             shared:true,
             timeStamp:timeStamp._d,
             owner:user.email,
             owner_name:user.displayName,
             owner_photo:user.photoURL
        })
        await setShare(false)
        await setAlert(true)

    }

    useEffect(() => {
        const unSubscribe = async () =>{

            const queryRef = query(
                collection(db, "stacks"),
                where("itemDocId","==",itemDocId),
                limit(initial)
           );

           await onSnapshot(queryRef,(snapshot) =>{
               let resArry = []
               if(snapshot.empty) {console.log("empty snapshot")}
               snapshot.forEach(doc =>{
                resArry.push({
                   id:doc.data().id,
                   title:doc.data().title,
                   label_id:doc.data().label_id,
                   stackDocId:doc.id,
                   owner:doc.data().owner,
                   owner_name:doc.data().owner_name,
                   owner_photo:doc.data().owner_photo,
                   timeStamp:doc.data().timeStamp
                   });
               })
               setAllStacks(resArry)
           })
         }
         unSubscribe()
         return()=>unSubscribe()
    },[])


    return (
        <div>
            <Card interactive={true} id="card-item"
                style={{backgroundColor:'transparent'}}
                >
                <div id="just-bar">
                    <p id="p"  onClick={() => CopyToClipboardFn(title)}> 
                     {title}
                    </p>
                </div>
                <LinkPreview url={title} style={{margin:10}}/>
                <button id="more-button" onClick={()=>setVisible(prev=>!prev)}>
                       <Icon icon="more"  color="#ecf1f5" />
                      </button>
                      {shared ? <p id="caption" style={{padding:10,fontSize:13}} onClick={()=>showStacks(prev=>!prev)}> Stacks {allStacks.length <= 0 ? " ": allStacks.length} </p> 
                            : <p id="caption" style={{padding:10,fontSize:13}} onClick={()=>setVisible(prev=>!prev)}>Private</p>}
                      <p id="caption" style={{padding:10,fontSize:13}}>{moment.utc(timeNew).format('MMMM Do, h:mm:ss a')}</p>

                    <Collapse isOpen={stack} >
                        {allStacks.length <= 0 ? <div/> 
                            : <div>
                                {allStacks.map(item=>(
                                    <Stack2 info={item}  key={item.id} />
                                ))}
                                </div>}
                    </Collapse>
            </Card>

             <Dialog isOpen={visible} style={{backgroundColor:'#30404D'}}>
                <button id="close-btn"onClick={()=>setVisible(prev=>!prev)} ><Icon icon="cross"  color="#ecf1f5" /></button>

                <div id="action-btn" onClick={()=>setEdit(prev=>!prev)}>
                        <Icon icon="edit" color="#ecf1f5" style={{marginRight:10}} /> 
                          edit item
                    </div>   

                <Collapse isOpen={edit}>
                      <input type="text" id="input" placeholder="edit item content"
                        value={new_name}
                        onChange={e=>setNewName(e.target.value)}
                         />
                        <button id="ok-update"  disabled={disabled} onClick={()=>updateItem()}>Update</button>
                    </Collapse>

                    <div id="action-btn" onClick={()=>deleteItem()}>
                        <Icon icon="trash" color="#ecf1f5" style={{marginRight:10}} /> 
                          Delete item
                    </div>

                    
                    <div id="action-btn" onClick={()=>setShare(prev=>!prev)}>
                        <Icon icon="share" color="#ecf1f5" style={{marginRight:10}} /> 
                          share item
                    </div>
             </Dialog>


              <Dialog isOpen={share} style={{backgroundColor:'#30404D'}}>
                    <h3 id="h3">
                        You are about to share your item on public,are you sure ?
                    </h3>
                <div>
                <button id="ok" style={{opacity:0.6}}>Cancel</button>
                    <button id="ok" onClick={()=>shareItem()}>Yes, share</button>
                </div>
              </Dialog>

              <Alert isOpen={alert}  onClose={()=>setAlert(prev=>!prev)}>
                  Item successfully shared with other users
              </Alert>
              <Alert isOpen={clipAlerts} onClose={()=>setClipAlerts(prev=>!prev)}>
                   Copied to clipboard
                  </Alert>
        </div>
    )
}

export default Item
